import project1 from "../../assets/images/project-images/socialMediaApp.webp";
import project2 from "../../assets/images/project-images/RealTimeChat.webp";
import project3 from "../../assets/images/project-images/DashBoradAdmin.webp";
import project4 from "../../assets/images/project-images/DexProjectImage.png";
import project5 from "../../assets/images/project-images/CatNotepad.webp";
import project6 from "../../assets/images/project-images/eCommerceStore.webp";
import project7 from "../../assets/images/project-images/cordwork.png";
import project8 from "../../assets/images/project-images/Staking.png";
import project9 from "../../assets/images/project-images/citybuilder.png";
import project10 from "../../assets/images/project-images/animated-website.png";

export const ProjectsData = [
  {
    projectImage: project1,
    projectTitle: "Social Media App",
    projectSubTITLE: "React · javascript · contextProvider · styled components",
    ProjectDiv: "div10",
    projectURL: "https://willcordeiro.github.io/SocialMediaGhpages/",
  },
  {
    projectImage: project2,
    projectTitle: "Real Time Chat",
    projectSubTITLE: "Node express · React · Socket io · mongoDB",
    ProjectDiv: "div2",
    projectURL: "https://github.com/willcordeiro/RealTimeChat",
  },
  {
    projectImage: project3,
    projectTitle: "Dashboard Admin",
    projectSubTITLE: "React · Tailwind · javascript · contextProvider",
    ProjectDiv: "div3",
    projectURL: "https://willcordeiro.github.io/dashboardAdmin/",
  },
  {
    projectImage: project5,
    projectTitle: "Cat notepad",
    projectSubTITLE:
      "React · typescript · context · styled components · react dnd",
    ProjectDiv: "div7",
    projectURL: "https://cat-notepad.vercel.app/",
  },
  {
    projectImage: project4,
    projectTitle: "Decentralized Exchange (DEX)",
    projectSubTITLE:
      "React · typescript · UniswapV2 · Web3 · Blockchain · Solidity",
    ProjectDiv: "div1",
    projectURL: "https://dex-ui-willcordeiro.vercel.app/#/swap",
  },
  {
    projectImage: project6,
    projectTitle: "eCommerceStore",
    projectSubTITLE: "React · ContextProvider · web development · javascript",
    ProjectDiv: "div9",
    projectURL: "https://willcordeiro.github.io/eCommerceStore/",
  },
  {
    projectImage: project7,
    projectTitle: "CordWork",
    projectSubTITLE: "React · Next ",
    ProjectDiv: "div6",
    projectURL: "https://landing-sell-sable.vercel.app/",
  },
  {
    projectImage: project8,
    projectTitle: "Staking Application",
    projectSubTITLE: "React · javascript · solidity · hardhat · Blockchain",
    ProjectDiv: "div8",
    projectURL: "https://github.com/willcordeiro/stakingApp",
  },
  {
    projectImage: project9,
    projectTitle: "City Builder",
    projectSubTITLE:
      "Three.js · React · Web Development · typescript · Next.js",
    ProjectDiv: "div5",
    projectURL: "https://city-builder-eta.vercel.app/",
  },
  {
    projectImage: project10,
    projectTitle: "full-animated-website",
    projectSubTITLE: "React · next · css",
    ProjectDiv: "div4",
    projectURL: "https://full-animated-website.vercel.app/",
  },
];
